import { Route, Routes, Link } from 'react-router-dom'
import SB from './sideBar';
import Container from './container';
import { useEffect, useState, useReducer } from 'react';

import { GiHamburgerMenu } from 'react-icons/gi';
import { useMediaQuery } from 'react-responsive'
import DashboardContext from '../contexts/dashboardContext';
import Navbar from './navbar';
import paths from '../config/paths.json';
import NavbarReducer from '../reducers/navbarReducer'
import NavKey from '../reducerKeys/navbarKey.json'
import RefreshToken from './../api/refreshToken'
import Storages from '../helper/storages';

export default function Dashboard() {
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 1024px)` });

  // const [navState, navDispatch] = useReducer(NavbarReducer, { isOpen: false })

  var [isOpen, setOpen] = useState(false);
  const openValue = { isOpen, setOpen };
  var [lastTime, setLastTime] = useState(new Date());
  var [favAddress, setFavAddress] = useState({});





  var onCreate = () => {
    // navState.Sidebar.element.style.visibility = '';
  }
  var open = () => {
    console.log("Sidebar is opened");
  }
  var close = () => {
    console.log("Sidebar is closed");
  }


  useEffect(() => {
    const timer = setInterval(() => {

      var lastTime
      setLastTime((prevTime) => { lastTime = prevTime; return prevTime; });
      var diffInSec = Math.abs(lastTime - new Date()) / 1000;

      if (diffInSec > Storages.getExtendedTokenTime()) {
        setLastTime(new Date());
        RefreshToken();
      }
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);


  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50

  const onTouchStart = (e) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX)

  }

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)

  }

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance
    if (isRightSwipe)
      setOpen(true);
    if (isLeftSwipe)
      setOpen(false);
    console.log('ssssssssssssssssss', 3)


    // add your conditional logic here
  }



  return (
    <DashboardContext.Provider value={{
      isOpen,
      setOpen,
      isMobile,
      favAddress,
      setFavAddress
    }}>


      <div className="d-flex vh-100  position-relative "
        style={{ zIndex: 0 }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}

      >



        {/* صفحه اصلی */}
        <div className="control-section vh-100 w-100 overflow-hidden"
        >

          <Navbar />

          <div id="wrapper  " >


            <div className='bg-contaner overflow-hidden '
              onTouchStart={() => {
                setOpen(false);
                console.log('ssssssssssssssssss', 1)
              }}
              onMouseUp={() => {
                setOpen(false);
                console.log('ssssssssssssssssss', 2)
              }} >
              <Container />
            </div>
          </div>

        </div>

        <div className='position-fixed start-0  col-10 col-sm-5 col-md-4 col-lg-3 bg-danger vh-100 overflow-auto' style={{ zIndex: isOpen ? 1 : -1 }}>
          <SB />
        </div>

      </div>



    </DashboardContext.Provider >

  );
}